@if (isLoading) {
<div class="post-page__state">{{'Loading blog post...' | translate }}</div>

} @else if (post) {
<!-- Blog Header Section -->
<header class="post-page blog-header mb-3">
  <h1>{{ post.title }}</h1>
  <div class="meta-info">
    {{'PUBLISHED_ON'| translate}} {{ post.createdAt | date: 'MMMM d, y' }} • {{'BY'| translate}} {{ post.author }} •
    {{'5MIN_READ'|translate}}
  </div>
</header>
<article class="post-page">

  @if (post.summary) {
  <div class="post-page__summary" [innerHTML]="post.summary"></div>
  }

  <div class="post-page__content" [innerHTML]="post.content || post.summary"></div>
  <div class="blog-card__keywords">
    @for(keyword of post.keywordArray; track keyword) {
    <a [routerLink]="['/', currentLang, 'blogs', keyword.replace(' ', '-')]"
      class="blog-card__keyword badge bg-secondary fs-6 me-1 my-1 p-2 text-decoration-none"><span>#{{ keyword }}</span></a>
    }
  </div>
</article>
} @else {
<div class="post-page__state">{{'No blog post was found.' | translate }}</div>
}